module.exports = __webpack_public_path__ + "static/media/xz05_grey.e8c97361.png";